// extracted by mini-css-extract-plugin
export default {"thumbnailsDesigner":"ThumbnailsDesigner_thumbnailsDesigner__D9h01","designerImage":"ThumbnailsDesigner_designerImage__eGkEd","designerText":"ThumbnailsDesigner_designerText__fSuNt"};